var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none",
    viewBox: "0 0 12 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7B7B7B",
    d: "M6.703 5.644c.194 0 .352.157.352.351v.352h-.703v-.352c0-.194.157-.351.351-.351z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B7B7B",
    d: "M0 6.698v-.703h2.836v-.703H.703v-.703h2.133V3.183h1.406V1.05h.703v2.133h.703V.347h.704v2.836h.703V1.05h.703v2.133h1.406v1.406h2.133v.703H9.164v.703H12v.703H9.164v.703h2.133v.703H9.164v1.407H7.758v2.133h-.703V9.51h-.703v2.836h-.704V9.51h-.703v2.133h-.703V9.51H2.836V8.104H.703v-.703h2.133v-.703H0zM4.242 4.94v2.813h.703V4.94h-.703zm2.813 2.11v.703h.703V5.995a1.056 1.056 0 00-2.11 0v1.758h.704V7.05h.703z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAi);
export default __webpack_public_path__ + "static/media/icon-ai.e20cc1f6.svg";
export { ForwardRef as ReactComponent };